export default __webpack_public_path__ + "static/media/notifications_11.944e530f.png";